import React from 'react'
import StatusCard from './StatusCard'
import { makeStyles } from '@material-ui/core/styles'
import { useMyBookings } from '../hooks/useMyBookings'
import { Error, Loader } from '../../../components'
import { extractResponse } from '../../../utils'

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.up('sm')]: {
            width: '75%',
            padding: theme.spacing(2),
        },
        width: '95%',
        margin: 'auto',
    },
}))

function Bookings() {
    const classes = useStyles()
    const { isLoading, data, error } = useMyBookings()

    if (isLoading) {
        return <Loader />
    }

    if (error) {
        return <Error error={error} />
    }

    const res = extractResponse(data)

    if (res?.error) {
        return <Error error={res.error} />
    }

    const bookings = res.data

    return (
        <section className={classes.container}>
            {bookings?.map((booking) => (
                <StatusCard key={booking.bookingId} booking={booking} />
            ))}
        </section>
    )
}

export default Bookings
